var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"plus"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"plus","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("polygon",{"id":"+","fill":"#000000","points":"8 11 0 11 0 8 8 8 8 0 11 0 11 8 19 8 19 11 11 11 11 19 8 19"}))]);
}

Plus.defaultProps = {"width":"19px","height":"19px","viewBox":"0 0 19 19","version":"1.1"};

module.exports = Plus;

Plus.default = Plus;



// WEBPACK FOOTER //
// ./src/icons/plus.svg